import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_SIGNMSS_FULFILLED = "FETCH_SIGNMSS_FULFILLED";
export const FETCH_SIGNMSS_REJECTED = "FETCH_SIGNMSS_REJECTED";
export const FETCH_SIGNMSS_PENDING = "FETCH_SIGNMSS_PENDING";
export const RESET_SIGNMSS = "RESET_SIGNMSS";


export function signMSS(content, handle, signed) {
    const token = localStorage.getItem("accessToken")
    return dispatch => {
        dispatch({
            type: "FETCH_SIGNMSS",
            payload: axios({
                method: "post",
                url: `https://shop.onedose.io/gate/cart/sign`,
                data: {content, handle, signed},
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                },
            }).then((result) => result.data),
        });
    };
}

export function resetSignMSS() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SIGNMSS",
        });
    };
}